/* eslint-disable react/prop-types*/
import React from "react";
import { Column, Cell } from "fixed-data-table";
import classNames from "classnames";

function createColumn(data, col, sortBy = [], setSort, tableWidth) {
  const {
    name,
    key,
    sortKeys,
    field,
    display,
    width,
    widthPct,
    reverseSortOrder,
    displayReverseSortOrder,
    isHeaderFilter,
  } = col;
  const [ASC, DESC] = reverseSortOrder
    ? ["asc", "desc"].reverse()
    : ["asc", "desc"];

  let allSortKeys = [];
  if (sortKeys) {
    allSortKeys = [...sortKeys];
  }
  if (key) {
    allSortKeys.push(key);
  }
  if (field) {
    allSortKeys.push(field);
  }
  const sorting = sortBy.find((sort) =>
    allSortKeys.some((sortKey) => sort.split(":")[0] == sortKey)
  );
  const sortClassName = classNames({
    sorting: sorting,
    "no-sort": !allSortKeys.length,
  });
  let colWidth = width;

  if (!colWidth) {
    colWidth = (tableWidth * widthPct) / 100;
  }

  const filterClassName = classNames({
    "filter-header": true,
    sorting: sorting,
  });
  let sortIndicator;
  if (isHeaderFilter)
    sortIndicator = <span className="datatable-sort sort-asc unselected-sort" />;
  if (sorting) {
    const sortOrder = sorting.split(":")[1];
    if (!!displayReverseSortOrder) {
      sortIndicator = <span className={`datatable-sort sort-${sortOrder}`} />;
    }
    else {
      if (sortOrder == ASC) {
        sortIndicator = <span className="datatable-sort sort-asc" />;
      } else {
        sortIndicator = <span className="datatable-sort sort-desc" />;
      }
    }
  }

  function toggleSort() {
    if (!allSortKeys.length) {
      return;
    }
    const direction = sorting
      ? sorting.split(":")[1] == ASC
        ? DESC
        : ASC
      : ASC;
    const newSort = allSortKeys.map((key) => `${key}:${direction}`);
    return setSort(newSort);
  }
  return (
    <Column
      key={name}
      header={
        isHeaderFilter ? (
          () => (
            <div className={filterClassName}>
              {name}
              <Cell
                onClick={toggleSort}
                className={sortClassName}
                style={{ width: "auto" }}
              >
                {sortIndicator}
              </Cell>
            </div>
          )
        ) : (
          <Cell
            onClick={toggleSort}
            className={sortClassName}
            style={{ minWidth: colWidth || 200 }}
          >
            {name} {sortIndicator}
          </Cell>
        )
      }
      cell={(props) =>
        data ? (
          <Cell style={{ minWidth: colWidth || 200 }}>
            {renderContents(field, display, data[props.rowIndex])}
          </Cell>
        ) : (
          false
        )
      }
      width={colWidth || 200}
    />
  );
}

function renderContents(field, display, data) {
  if (field) {
    return data[field];
  }
  return display(data);
}

export default createColumn;



// WEBPACK FOOTER //
// ./src/components/common/DataTable/createColumn.js